import { Http } from 'angular2/http';
import { Injectable } from 'angular2/core';

@Injectable()
export class BulletinService {
  bulletins;

  constructor(public http: Http) {
    this.bulletins = [];
    this.retrieveBulletins();
  }

  retrieveBulletins() {
    if(this.bulletins.length == 0) {
      // this.http.get('mock.json')
      //this.http.get('file:///android_asset/www/mock.json')
      this.http.get('https://www.ocgracefirst.com/wp-json/llch/v2/bulletins/recent')
          .subscribe(data => {
            var bulletins = data.json();
            var bulletin;
            while(bulletin = bulletins.shift()){
              this.bulletins.push(bulletin);
            }
          });
    }
  }

  getBulletins() {
    return this.bulletins;
  }
}